import { createApp } from "vue";
import MainNav from "./components/main-nav";
import CookieModal from "./components/cookie-modal";
import CookieCustomization from "./components/cookie-management";

const mainNavApp = createApp();
mainNavApp.component("c-main-nav", MainNav);
mainNavApp.mount("#main-nav-container");

if (document.getElementById("cookie-modal-container")) {
    const cookieBanner = createApp();
    cookieBanner.component("c-cookie-modal", CookieModal);
    cookieBanner.mount("#cookie-modal-container");
}

if (document.getElementById("cookie-customization-container")) {
    const cookieMgr = createApp();
    cookieMgr.component("c-cookie-management", CookieCustomization);
    cookieMgr.mount("#cookie-customization-container");
}
